<template>
  <div class="leaderboard">
    <BaseText11 class="loading" ref="loading" text="Loading"/>
    <div class="swiper-container" ref="swiper-container">
      <BaseSwiper
        class="swiper"
        ref="swiper"
        :options="{
          initialSlide,
          spaceBetween: 100,
          allowTouchMove: !postResultsMode,
          pagination: { el: !postResultsMode ? pagination : null }
        }"
      >
        <SwiperSlide v-for="id in opponentIds" :key="id">
          <OpponentLeaderboard
            ref="opponent-leaderboard"
            :opponent-id="id"
          />
        </SwiperSlide>
        <template #footer>
          <div class="navigation">
            <template v-if="!postResultsMode">
              <div class="arrows">
                <BaseButtonArrow direction="left" @click.native="$refs['swiper'].swiper.slidePrev()"/>
                <BaseButtonArrow direction="right" @click.native="$refs['swiper'].swiper.slideNext()"/>
              </div>
              <div class="pagination" ref="pagination"/>
            </template>
            <router-link to="/share" v-else>
              <BaseButtonOctagon class="button" text="Next"/>
            </router-link>
          </div>
        </template>
      </BaseSwiper>
    </div>
  </div>
</template>

<script>
import { opponentIds } from '@/data/opponents'
import BaseSwiper from '@/components/BaseSwiper/BaseSwiper'
import BaseText11 from '@/components/BaseText11/BaseText11'
import BaseButtonArrow from '@/components/BaseButtonArrow/BaseButtonArrow'
import SwiperSlide from '@/components/BaseSwiper/components/SwiperSlide/SwiperSlide'
import OpponentLeaderboard from './partials/OpponentLeaderboard/OpponentLeaderboard'
import BaseButtonOctagon from '@/components/BaseButtonOctagon/BaseButtonOctagon'
import { TimelineMax, Power1 } from 'gsap'
export default {
  name: 'leaderboard',
  components: {
    BaseText11,
    BaseSwiper,
    SwiperSlide,
    BaseButtonArrow,
    OpponentLeaderboard,
    BaseButtonOctagon
  },
  props: {
    initialSlide: {
      type: Number,
      default: 0
    },
    postResultsMode: {
      type: Boolean,
      default: false
    }
  },
  async mounted () {
    this.tl = this.createTl()
    this.pagination = this.$refs['pagination']
    this.$store.commit('ui/setLoading', true)
    await Promise.all(this.$refs['opponent-leaderboard'].map(component => component.fetchData()))
    this.$store.commit('ui/setLoading', false)
    this.tl.play()
  },
  beforeDestroy () {
    this.$store.commit('ui/setLoading', false)
  },
  data () {
    return {
      pagination: null
    }
  },
  computed: {
    opponentIds () {
      return opponentIds
    }
  },
  methods: {
    fetchSlideData (i) {
      this.$refs['opponent-leaderboard'][i].fetchData()
    },
    createTl () {
      const tl = new TimelineMax({ paused: true })
      tl.to(this.$refs['loading'].$el, 0.5, { autoAlpha: 0, ease: Power1.easeInOut })
      tl.from(this.$refs['swiper-container'], 0.5, { autoAlpha: 0, ease: Power1.easeInOut })
      return tl
    }
  }
}
</script>

<style lang="scss" scoped>
.leaderboard * {
  user-select: none;
}
.leaderboard,
.swiper-container {
  width: 100%;
  height: 100%;
  position: relative;
}
.swiper,
::v-deep .swiper {
  width: 100%;
  flex: 1;
}
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.navigation {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.arrows {
  display: flex;
  margin-top: var(--spacing-1);
  > *:not(:last-child) { margin-right: 0.5rem }
  > * { pointer-events: all }
}
.pagination {
  width: 100%;
  position: relative;
  max-width: 40rem;
  margin-top: var(--spacing-1);
}
</style>
